export const resolution = [16, 9];

export const MagicDiceCanvasMobileConfigs = {
  antialias: true,
  backgroundAlpha: 0,
  width: 1024,
  height: 1334,
};

export const MagicDiceCanvasWebConfigs = {
  antialias: true,
  backgroundAlpha: 0,
  width: 1920,
  height: 1080,
};

export const mobileConfigs = {
  width: 1024,
  height: 1334,
  bgScale: null,
  textureScale: 0.5,
  winNumberStyle: {
    fill: 0xffd560,
    fontFamily: 'Lato',
    fontSize: 140,
    fontWeight: 750,
  },
  dicesFirstPositions: [
    {
      x: 490,
      y: 410,
    },
    {
      x: 640,
      y: 425,
    },
    {
      x: 800,
      y: 440,
    },
    {
      x: 570,
      y: 555,
    },
    {
      x: 730,
      y: 560,
    },
  ],

  dicesSecondPositions: [
    {
      x: 450,
      y: 390,
    },
    {
      x: 540,
      y: 480,
    },
    {
      x: 820,
      y: 390,
    },
    {
      x: 650,
      y: 510,
    },
    {
      x: 750,
      y: 480,
    },
  ],

  get winNumberStaticPosition() {
    return {
      x: 635,
      y: -400,
    };
  },

  get winNumberAnimationPosition() {
    return {
      x: 635,
      y: 330,
    };
  },

  get bgPosition() {
    return {
      x: this.width / 2 - 80,
      y: this.height / 2 - 50,
    };
  },

  get dancerAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height + 400,
    };
  },

  get chestAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height + 410,
    };
  },

  get config() {
    return {
      width: this.width,
      height: this.height,
    };
  },

  get chestInteriorPosition() {
    return {
      x: 640,
      y: 750,
    };
  },
};

export const webConfigs = {
  width: 1920,
  height: 1080,
  winNumberStyle: {
    fill: 0xffd560,
    fontFamily: 'Lato',
    fontSize: 140,
    fontWeight: 750,
  },
  dicesFirstPositions: [
    {
      x: 930,
      y: 190,
    },
    {
      x: 1080,
      y: 205,
    },
    {
      x: 1250,
      y: 200,
    },
    {
      x: 1000,
      y: 335,
    },
    {
      x: 1160,
      y: 335,
    },
  ],

  dicesSecondPositions: [
    {
      x: 930,
      y: 230,
    },
    {
      x: 1000,
      y: 320,
    },
    {
      x: 1130,
      y: 360,
    },
    {
      x: 1260,
      y: 330,
    },
    {
      x: 1330,
      y: 230,
    },
  ],

  get winNumberStaticPosition() {
    return {
      x: 1130,
      y: -400,
    };
  },

  get winNumberAnimationPosition() {
    return {
      x: 1130,
      y: 200,
    };
  },

  get bgPosition() {
    return {
      x: this.width / 2,
      y: this.height / 2 - 50,
    };
  },

  get chestInteriorPosition() {
    return {
      y: 610,
      x: 1130,
    };
  },

  get staticAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height - 50,
    };
  },

  get dancerAnimationPosition() {
    return {
      x: this.width / 2 + 50,
      y: this.height + 20,
    };
  },

  get chestAnimationPosition() {
    return {
      x: this.width / 2 + 50,
      y: this.height + 20,
    };
  },

  get config() {
    return {
      width: this.width,
      height: this.height,
    };
  },
};
